module.exports = __webpack_public_path__ + "static/img/Geos-2022-Angela.b3958d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Angela.png
// module id = RZkO
// module chunks = 0